import * as React from 'react'
import styled, { useTheme } from 'styled-components'
import Avatar from '../Avatar/Avatar'
import { Link } from 'react-router-dom'
import ERoute from '../../../ERoute'
import { Conversation, ConversationMessageText, ConversationMessageType } from '../../../../types'
import Icon from '../../../../components/Icons/Icon'
import { generatePath } from '../../../utilities/RouteHelper'
import { useSelector } from 'react-redux'
import { AppState } from '../../../store'
import moment from '../../../../utilities/Moment'
import ConversationHelper from '../../../../helpers/ConversationHelper'
import { WidgetHelper } from '../../../helpers'
import showdown from '../../../../utilities/showdown'

const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400 !important;
  max-height: 16px;

  p {
    margin: 0;
  }

  a {
    color: black;
  }
`

const Action = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`

const Container = styled(Link) <{ $unread: boolean }>`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  padding: 16px 20px;
  align-items: center;
  transition: color 250ms, background-color 250ms;
  opacity: 1;
  cursor: pointer;
  position: relative;
  gap: 16px;
  text-decoration: none;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  &::after {
    content: "";
    height: 1px;
    background: rgba(20, 22, 26, 0.06);
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
  }

  ${Title} {
    font-weight: 500;
  }

  ${Action} {
    svg {
      width: 15px;
      height: 15px;
    }
  }
`

const AvatarContainer = styled.div`
  width: 35px;
  height: 35px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  width: 100%;
  overflow: hidden;
`



const Description = styled.div`
  display: flex;
  font-weight: 300;
  font-size: 14px;
  color: rgb(102, 102, 102);
  white-space: break-spaces;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface IProps {
  conversation: Conversation
}

const ConversationItem = (props: IProps) => {
  const { conversation } = props
  const { message: lastMessage, description } = ConversationHelper.getLastMessageMetadata(conversation, false)
  const { widget } = useSelector((state: AppState) => state.application)
  const theme = useTheme()

  let authorName = widget.name
  // @ts-ignore
  let avatarUrl = WidgetHelper.logoUrl(theme.color.background)

  if (conversation?.assignee) {
    if (conversation?.assignee.name) authorName = conversation.assignee.name
    if (conversation.assignee.avatar_url) avatarUrl = conversation.assignee.avatar_url
  } else if (conversation.messages?.length > 0) {
    const agentMessage = conversation.messages.find(message => !message.client_assigned_id)

    if (agentMessage?.author?.avatar?.url) {
      if (agentMessage.author.name) authorName = agentMessage.author.name
      if (agentMessage?.author?.avatar?.url) avatarUrl = agentMessage.author.avatar.url
    }
  }

  const unread = !conversation.user_read

  return (
    <Container to={generatePath(ERoute.PATH_CONVERSATION, { id: conversation.id })} $unread={unread}>
      <AvatarContainer>
        <Avatar
          name={authorName}
          width={40}
          src={avatarUrl}
          rounded
        />
      </AvatarContainer>

      <Content>
        <Title dangerouslySetInnerHTML={{ __html: showdown.makeHtml(description) }} />
        <Description>
          {authorName} • {moment(lastMessage?.created_at).fromNow()}
        </Description>
      </Content>

      <Action>
        {!unread && <Icon icon='messenger-chevron-right' />}
        {unread && <Icon icon='messenger-indicator' />}
      </Action>
    </Container>
  )
}

export default ConversationItem